import React, { useState } from 'react';
import css from './PdfHelper.module.scss';
import { Document, Page, pdfjs } from 'react-pdf';
import { Spinner } from '../Spinner/Spinner';
/*
 * Import the worker as a URL asset. pdfjs-dist 2.x ships `pdf.worker.entry.js`
 * as a CommonJS side-effect entry for webpack, which breaks Vite's ESM loader.
 * Loading pdf.worker.min.js with the ?url query produces a plain string URL that
 * pdfjs.GlobalWorkerOptions.workerSrc accepts directly.
 */
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.min.js?url';

export interface IPdfHelperProps {
    src: string | undefined;
    className?: string;
    pageWidthPx?: number;
    pdfHeightChanged?: (height: number) => void;
}

export const PdfHelper = React.memo((props: IPdfHelperProps) => {
    pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

    const [numPages, setNumPages] = useState<number | null>(null);
    const [loading, setLoading] = useState(true);

    async function onDocumentLoadSuccess(data: any) {
        setNumPages(data.numPages);
        if (data?.numPages !== 0 && props.pdfHeightChanged) {
            const pageWidth = (await data.getPage(1)).view[2];
            let allPagesHeight = 0;
            for (let i = 1; i <= data.numPages; ++i) {
                const page = await data.getPage(i);
                allPagesHeight += page.view[3];
            }
            props.pdfHeightChanged(Math.floor(allPagesHeight * ((props.pageWidthPx ?? pageWidth) / pageWidth) + 25 * (data.numPages - 1)));
        }
        setLoading(false);
    }

    return (
        <div className={props.className}>
            <Document file={props.src} onLoadSuccess={onDocumentLoadSuccess}>
                {Array.apply(null, Array(numPages))
                    .map((x, i) => i + 1)
                    .map((page) => (
                        <Page
                            width={props.pageWidthPx}
                            pageNumber={page}
                            renderAnnotationLayer={false}
                            className={css.page}
                            key={'pdfpage' + page}
                        />
                    ))}
            </Document>
            {loading && (
                <div className={css.spinnerContainer} style={{ width: props.pageWidthPx + 'px' }}>
                    <Spinner />
                </div>
            )}
        </div>
    );
});
PdfHelper.displayName = 'PdfHelper';
